import { account } from "./account.fr";
import { actions } from "./actions.fr";
import { addStep } from "./cart.fr";
import { checkout } from "./checkout.fr";
import { cms } from "./cms.fr";
import { cookies } from "./cookies.fr";
import { discount } from "./discount.fr";
import { errorPage } from "./error-page.fr";
import { footer } from "./footer";
import { forms } from "./forms.fr";
import { login } from "./login.fr";
import { notifications } from "./notifications.fr";
import { orderDetails } from "./order-details.fr";
import { orderListElement, orderList } from "./orderlist-element.fr";
import { printmode } from "./printmode.fr";
import { processingSteps } from "./processing-steps.fr";
import { register } from "./register.fr";
import { repairAnalysisInfo } from "./repairAnalysisInfo.fr";
import { welcomeJomatik } from "./welcome-jomatik.fr";

export const fr = {
  account,
  actions,
  addStep,
  checkout,
  cms,
  cookies,
  discount,
  errorPage,
  footer,
  forms,
  login,
  notifications,
  orderDetails,
  orderList,
  orderListElement,
  printMode: printmode,
  processingSteps,
  register,
  repairAnalysisInfo,
  welcomeJomatik,
};
